import React, { useState, useEffect } from "react";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Badge from 'react-bootstrap/Badge';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Table from 'react-bootstrap/Table';
import { useNavigate } from "react-router-dom";


function Pricing({ setPricingModal, planId }) {
    const [timeradio, setTimeRadio] = useState(2);
    const [currencyradio, setCurrencyRadio] = useState(1);
    const [planData, setPlanData] = useState();
    // const [zones, setZones] = useState(["a"]);
    const [pricingData, setPricingData] = useState();
    const loggedInUserId = sessionStorage.getItem('userid');
    const navigate = useNavigate()
    const userPlanId = parseInt(sessionStorage.getItem("planid"));

    const handleGetStartedClick = (id, type) => {
        // setPricingModal(false)
        if(userPlanId === 7){
            navigate(`/signup?id=${id}&type=${type}&period=${timeradio}&currency=${currencyradio}`)
        }else{
            navigate(`/accountdetails?id=${id}&type=${type}&period=${timeradio}&currency=${currencyradio}`)
        }
    };
    const timeOptions = [
        { name: 'Monthly', value: 1 },
        { name: 'Yearly', value: 2 },
    ];

    const currencyOptions = [
        { name: "INR", value: 1 },
        { name: "USD", value: 2 },
    ];

    // const zoneOptions = [
    //     { name: "Zone A", value: "a" },
    //     { name: "Zone B", value: "b" },

    // ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`/getprices/${currencyradio}`);
                setPlanData(response.data);
                const pricingresponse = await axios.get(`/getpricing`);
                setPricingData(pricingresponse.data)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [currencyradio]);

    useEffect(() => {
        const fetchCurrency = async () => {
            try {
                const publicIP = await axios.get('https://api.ipify.org?format=json');
                const response = await axios.get(`/ipInfo/${publicIP.data.ip}`);
                if (response.data.ipInfo.countryCode === 'IN') {
                    setCurrencyRadio(1);
                    // setZones(["a"]);
                } else {
                    setCurrencyRadio(2);
                    // setZones(["b"])
                }
            } catch (error) {
                console.error('Error fetching IP info:', error);
            }
        };

        fetchCurrency();
    }, []);


    // const getFormatedPriceForPlan = (planid, type, zones) => {
    //     if (!planData || zones.length === 0) return 0;
    //     const zonePlans = planData.filter(item => item.planid === parseInt(planid) && zones.includes(item.zone));

    //     if (zonePlans.length === 0) return 0;

    //     let totalPrice = 0;

    //     for (let plan of zonePlans) {
    //         const price = parseInt(type) === 1 ? plan.monthlyfee : Math.ceil(plan.annualfee / 12);
    //         totalPrice += price;
    //     }

    //     return totalPrice.toLocaleString('en-IN');
    // };

    const getFormatedPriceForPlan = (planid, type) => {
        if (planData) {
            const plan = planData.find(item => item.planid === planid);
            if (plan) {
                const price = type == 1 ? plan.monthlyfee : Math.ceil(plan.annualfee / 12);
                return price.toLocaleString('en-IN'); // Format the price with commas
            }
            return 0;
        }
        return 0;
    };

    const getAnnualTotalPriceForPlan = (planid, type) => {
        if (planData) {
            const plan = planData.find(item => item.planid === planid);
            if (plan) {
                const price = type == 1 ? (plan.monthlyfee) * 12 : plan.annualfee;
                return price.toLocaleString('en-IN'); // Format the price with commas
            }
            return 0;
        }
        return 0;
    };

    // const getAnnualTotalPriceForPlan = (planid, type, zones) => {
    //     if (!planData || zones.length === 0) return 0;
    //     const zonePlans = planData.filter(item => item.planid === parseInt(planid) && zones.includes(item.zone));

    //     if (zonePlans.length === 0) return 0;

    //     let totalPrice = 0;

    //     for (let plan of zonePlans) {
    //         const price = parseInt(type) === 1 ? (plan.monthlyfee) * 12 : plan.annualfee;

    //         totalPrice += price;
    //     }

    //     return totalPrice.toLocaleString('en-IN');
    // };

    // const getPerUserPriceForPlan = (planid, type) => {
    //     if (planData) {
    //         const plan = planData.find(item => parseInt(item.planid) === parseInt(planid));
    //         if (plan) {
    //             const price = parseInt(type) === 1 ? currencyradio === 1 ? Math.ceil((plan.monthlyfee) / plan.maxusers) : parseFloat(((plan.monthlyfee) / plan.maxusers).toFixed(1)) : currencyradio === 1 ? Math.ceil(((plan.annualfee) / 12) / plan.maxusers) : parseFloat((((plan.annualfee) / 12) / plan.maxusers).toFixed(1));
    //             return price.toLocaleString('en-IN'); // Format the price with commas
    //         }
    //         return 0;
    //     }
    //     return 0;
    // };

    const getPlanDisabled = (planid) => {
        if (parseInt(userPlanId) === parseInt(planid)) {
            return true;
        } else {
            return false;
        }
    }

    // const handleZoneChange = (value) => {
    //     setZones((prevZones) =>
    //         prevZones.includes(value)
    //             ? prevZones.filter((z) => z !== value)
    //             : [...prevZones, value]
    //     );
    // };

    // const zoneDescriptions = {
    //     a: {
    //         phase1: 'United States of America',
    //         phase2: 'UK, Japan, Australia, etc.',
    //     },
    //     b: {
    //         phase1: 'India',
    //         phase2: 'Brazil, Thailand, Egypt, etc.',
    //     },
    // };

    // const boxStyle = {
    //     width: '210px',
    //     height: '130px',
    //     overflowY: 'auto',
    //     border: '1px solid #ccc',
    //     borderRadius: '8px',
    //     padding: '8px',
    //     backgroundColor: '#f8fafc',
    //     textAlign: 'start'
    // };

    const getValue = (currency, field) => {
        // const zoneStr = Array.isArray(zone) 
        //     ? zone.slice().sort().join("")
        //     : zone.split("").sort().join("");
        
        const entry = pricingData.find((item) => item.currencyid === currency);
    
        const value = entry ? entry[field] : null;
        return value !== null && value !== undefined ? Number(value).toFixed(2) : "-";
    };

    const sendMail = async () => {
        try {
            const response = await axios.get(`/sendcontactusmail/${loggedInUserId}`);
            console.log("response", response)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleGetStartedFreePlan = () => {
        // setPricingModal(false);   // Close the modal
        navigate('/signup');      // Redirect to signup
    };

    return (
        <>
        {/* Internal CSS */}
        <style>
            {`
            @media (max-width: 420px) {
                .pricing-toggle .btn {
                font-size: 0.5rem;
                padding: 0.25rem 0.5rem;
                }
                .pricing-toggle .badge {
                font-size: 0.55rem;
                top: -24px;
                }
                .pricing-header {
                font-size: medium; 
                margin-bottom: 18px;
                display: flex;
                justify-content: center;

                }
            }
            `}
        </style>
         <div style={{height:'90vh', overflowY:'scroll'}}>
            <Container >
                <Row className="d-flex align-items-center justify-content-lg-between justify-content-center mt-4 px-4">
                    <Col md="auto" className="mt-4">
                    <h4 style={{color:"#28749e"}} className="pricing-header"><strong>Unlimited data access for a flat fee.</strong></h4>
                    </Col>
                    <Col md="auto" className="mt-4 d-flex gap-2 flex-wrap pricing-toggle">
                    <Col className="d-flex align-items-center justify-content-center">
                        <ButtonGroup toggle>
                            {timeOptions.map((option, idx) => (
                                <div key={idx} className="position-relative">
                                    {option.name === 'Yearly' && (
                                        <Badge
                                            pill
                                            bg="success"
                                            className="position-absolute"
                                            style={{ top: '-32px', left: '50%', transform: 'translateX(-50%)', fontSize: '0.7rem', padding: '0.5rem 0.5rem' }}
                                        >
                                            Save up to 50%
                                        </Badge>
                                    )}
                                    <ToggleButton
                                        key={idx}
                                        id={`time-option-${idx}`}
                                        type="radio"
                                        variant="outline-primary"
                                        name="timeOptions"
                                        value={option.value}
                                        checked={timeradio === option.value}
                                        onChange={(e) => setTimeRadio(parseInt(e.currentTarget.value))}
                                        className="px-4 me-2"
                                        size="sm"
                                    >
                                        {option.name}
                                    </ToggleButton>
                                </div>
                            ))}
                        </ButtonGroup>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center">
                        <ButtonGroup toggle>
                            {currencyOptions.map((option, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`currency-option-${idx}`}
                                    type="radio"
                                    variant="outline-primary"
                                    name="currencyOptions"
                                    value={option.value}
                                    checked={currencyradio === option.value}
                                    onChange={(e) => setCurrencyRadio(parseInt(e.currentTarget.value))}
                                    className="px-4 me-2"
                                    size="sm"
                                >
                                    {option.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                    </Col>
                    </Col>
                </Row>

                <Row className="d-flex align-items-strech justify-content-center mt-1 px-4">
                    <Col md={12} lg={6} className="mt-4">
                        <Card style={{ height: "100%" }} className="shadow">
                            <Card.Body className="text-center px-0">
                                <span style={{ backgroundColor: "#a6a3a3", height: '10px', position: 'absolute', top: '-0.5625rem', right: '-0.125rem', width: `calc(100% + 0.25rem)` }}></span>
                                <Card.Title>Free</Card.Title>
                                <Card.Text>
                                    {/* <h4><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>0<sapn style={{ color: 'grey', fontSize: '12px' }}>/month</sapn></h4>
                                    <br /> */}
                                    <h4 className="d-flex align-items-center justify-content-center mb-4">
                                        <span className="me-1">{currencyradio === 1 ? '\u20B9' : '$'}</span>
                                        <div className="d-flex">
                                            <div style={{ fontSize: '26px', fontWeight: '600' }}>
                                                0
                                            </div>
                                            <div className="d-flex flex-column ms-2 align-items-start" style={{ lineHeight: '1.2' }}>
                                                <span style={{ fontSize: '12px', color: 'grey' }}>
                                                    /month
                                                </span>
                                                <span style={{ fontSize: '14px', color: 'grey' }}>
                                                    {timeradio === 1 ? 'billed monthly' : 'billed annually'}
                                                </span>
                                            </div>

                                        </div>
                                    </h4>
                                    <br />
                                    <Button style={{ borderRadius: '50px' }} size="md" className={`px-4 mt-1 mx-auto ${getPlanDisabled(7) === true ? 'd-block' : 'd-none'}`} disabled={getPlanDisabled(3) || getPlanDisabled(2)} variant={getPlanDisabled(2) === true ? "success" : "primary" } onClick={handleGetStartedFreePlan}>
                                        Get Started
                                    </Button>
                                    <Badge
                                        pill
                                        bg="success"
                                        className={`px-5 mt-1 fs-6 py-2 ${getPlanDisabled(2) === true ? 'd-inline-block' : 'd-none'}`}
                                    >
                                        Active
                                    </Badge>
                                    <div className="d-flex justify-content-center mt-3">
                                        <ListGroup className="text-start" variant="flush">
                                            <br />
                                            {/* <ListGroup.Item><i class="bi bi-check2-all me-2"></i>First 2 days: Unlimited Leads</ListGroup.Item> */}
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Only top 5 Leads visible; rest masked</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>All Fields Included</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Full Database Online Access</ListGroup.Item>
                                        </ListGroup>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={12} lg={6} className="mt-4">
                        <Card style={{  height: "auto", minHeight: "28rem" }} className="shadow" border="primary">
                            <Card.Body className="text-center px-0">
                                <span style={{ backgroundColor: "#28749e", height: '12px', position: 'absolute', top: '-0.5rem', right: '-0.1rem', width: `calc(100% + 0.25rem)` }}></span>
                                <Card.Title>Premium</Card.Title>
                                <Card.Text>
                                    <h4 className="d-flex align-items-center justify-content-center">
                                        <span className="me-1">{currencyradio === 1 ? '\u20B9' : '$'}</span>
                                        <div className="d-flex">
                                            <div style={{ fontSize: '26px', fontWeight: '600' }}>
                                                {getFormatedPriceForPlan(3, timeradio)}
                                            </div>
                                            <div className="d-flex flex-column ms-2 align-items-start" style={{ lineHeight: '1.2' }}>
                                                <span style={{ fontSize: '12px', color: 'grey' }}>
                                                    /month
                                                </span>
                                                <span style={{ fontSize: '14px', color: 'grey' }}>
                                                    {timeradio === 1 ? 'billed monthly' : 'billed annually'}
                                                </span>
                                            </div>
                                        </div>
                                    </h4>
                                    {currencyradio === 1 ?
                                        <div>  
                                            <span>
                                                +18% GST applicable
                                            </span>
                                        </div>:
                                    ''}
                                    <div className="d-flex align-items-center justify-content-center">
                                        <p><strong>Annual Billing  : <span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getAnnualTotalPriceForPlan(3, timeradio)}</strong></p>
                                    </div>
                                    {/* <Button onClick={() => handleGetStartedClick(3, 'subscription')} style={{ borderRadius: '50px' }} size="md" className="px-4 mt-2 mb-2" disabled={getPlanDisabled(3) || zones.length === 0} variant={getPlanDisabled(3) === true ? `outline-secondary` : `outline-primary`}>
                                        Get Started
                                    </Button> */}
                                    <Button onClick={() => handleGetStartedClick(3, 'subscription')} style={{ borderRadius: '50px' }} size="md" className={`px-4 mt-2 mb-2 mx-auto ${getPlanDisabled(1) === true || getPlanDisabled(3) === true ? 'd-none' : 'd-block'}`} disabled={getPlanDisabled(3)} variant={getPlanDisabled(3) === true ? "success" : "primary" }>
                                        {getPlanDisabled(3) === true ? "Active" :"Get Started"}
                                    </Button>
                                    <Badge
                                        pill
                                        bg="success"
                                        className={`px-5 mt-1 fs-6 py-2 ${getPlanDisabled(3) === true ? 'd-inline-block' : 'd-none'}`}
                                    >
                                        Active
                                    </Badge>
                                    {/* <p>{timeradio === 1 ? 'Montly' : 'Annual'} Subscription fee <span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{timeradio === 1 ? getFormatedPriceForPlan(3, timeradio, zones) : getAnnualTotalPriceForPlan(3, timeradio)}<br /></p> */}
                                    <div className="d-flex justify-content-center mt-4 mb-2">
                                        <ListGroup className="text-start" variant="flush">
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Unlimited Leads</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>All Fields Included</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Full Database Online Access for respective zone</ListGroup.Item>
                                        </ListGroup>
                                    </div>
                                    {/* <div className="d-flex gap-3 justify-content-center flex-wrap">
                                        {zoneOptions.map((option, idx) => {
                                            const info = zoneDescriptions[option.value]; // A or B

                                            return (
                                                <div key={idx} style={boxStyle}>
                                            <Form.Check
                                                type="checkbox"
                                                id={`zone-checkbox-${idx}`}
                                                label={option.name}
                                                value={option.value}
                                                checked={zones.includes(option.value)}
                                                onChange={() => handleZoneChange(option.value)}
                                                        className="mb-1"
                                            />
                                                    <div style={{ fontSize: '0.8rem', whiteSpace: 'pre-line' }}>
                                                        {info?.phase1}<br /><br />
                                                        <strong>Coming soon:</strong><br />
                                                        {info?.phase2}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div> */}
                                </Card.Text>
                                {/* {zones.length === 0 && (
                                    <div style={{ color: "red", fontSize: "14px" }}>
                                        Please select at least one zone.
                                    </div>
                                )} */}
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* <Col className="mt-4">
                        <Card style={{ height: "24rem" }} className="shadow" >
                            <Card.Body className="text-center px-0">
                                <span style={{ backgroundColor: "#a6a3a3", height: '10px', position: 'absolute', top: '-0.5625rem', right: '-0.125rem', width: `calc(100% + 0.25rem)` }}></span>
                                <Card.Title>Custom</Card.Title>
                                <Card.Text>
                                    <h4><span></span>Custom Price</h4>
                                    <Button style={{ borderRadius: '50px' }} size="md" className="px-4 mt-2 mb-4" variant="outline-primary" href="https://wowleads.com/index.html#contact" target="_blank" onClick={sendMail}>
                                        Contact Sales
                                    </Button>
                                    <div className="d-flex justify-content-center mt-4">
                                        <ListGroup className="text-start" variant="flush">
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Unlmimted Leads</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>All fields included</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Full Database Access</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Unlimited Export</ListGroup.Item>
                                            <ListGroup.Item><i class="bi bi-check2-all me-2"></i>Multiple Outreach Options</ListGroup.Item>
                                        </ListGroup>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col> */}

                </Row>
                {pricingData && pricingData.length !== 0 ? (<>  <Row className="mt-4 px-4">
                    <Table bordered hover responsive >
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: "#28749e", width: "40%", textAlign: "center", color:"white" }}>Feature</th>
                                <th style={{ backgroundColor: "#28749e", width: "20%", textAlign: "center", color:"white" }}>IN {currencyradio === 1 ? 'INR' : 'USD'}</th>
                                {/* <th style={{ backgroundColor: "#28749e", width: "20%", textAlign: "center", color:"white" }}>Zone B (Per Lead)</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {/* Data Export */}
                            <tr>
                                <td style={{ backgroundColor: "#ffffff", verticalAlign: "middle" }}>
                                    <strong>Email ID Export</strong><br /><small>(Website URL+Email IDs Only)</small>
                                </td>
                                <td style={{ backgroundColor: "#ffffff", textAlign: "center" }}><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getValue(currencyradio, "emailidexport")}</td>
                                {/* <td style={{ backgroundColor: "#ffffff", textAlign: "center" }}><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getValue(currencyradio, "dataexport")}</td> */}
                            </tr>
                            {/* <tr>
                                <td style={{ backgroundColor: "#28749e", color: "white", textAlign: "center" }}>${getValue("b", 2, "dataexport")}</td>
                                <td style={{ backgroundColor: "#28749e", color: "white", textAlign: "center" }}>₹{getValue("b", 1, "dataexport")}</td>
                            </tr> */}

                            {/* Outreach */}
                            <tr>
                                <td style={{ backgroundColor: "#ffffff", verticalAlign: "middle" }}>
                                    <strong>Full Lead Export</strong><br />
                                    <small>(Includes All Fields Per Lead)</small>
                                </td>
                                <td style={{ backgroundColor: "#ffffff", textAlign: "center" }}><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getValue(currencyradio, "fullleadexport")}</td>
                                {/* <td style={{ backgroundColor: "#ffffff", textAlign: "center" }}><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getValue(currencyradio, "outreach")}</td> */}
                            </tr>
                            {/* <tr>
                                <td style={{ backgroundColor: "#28749e", color: "white", textAlign: "center" }}>${getValue("b", 2, "outreach")}</td>
                                <td style={{ backgroundColor: "#28749e", color: "white", textAlign: "center" }}>₹{getValue("b", 1, "outreach")}</td>
                            </tr> */}

                            {/* Subscribe / Follow */}
                            <tr>
                                <td style={{ backgroundColor: "#ffffff", verticalAlign: "middle" }}>
                                    <strong>Outreach</strong><br />
                                    <small>(For each Contact Form Submittal, Social Media DM) <br />(After purchase of corresponding Full Lead Export)</small>
                                </td>
                                <td style={{ backgroundColor: "#ffffff", textAlign: "center" }}><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getValue(currencyradio, "outreach")}</td>
                                {/* <td style={{ backgroundColor: "#ffffff", textAlign: "center" }}><span>{currencyradio === 1 ? '\u20B9' : '$'}</span>{getValue(currencyradio, "socialmediasubscription")}</td> */}
                            </tr>
                            {/* <tr>
                                <td style={{ backgroundColor: "#28749e", color: "white", textAlign: "center" }}>${getValue("b", 2, "socialmediasubscription")}</td>
                                <td style={{ backgroundColor: "#28749e", color: "white", textAlign: "center" }}>₹{getValue("b", 1, "socialmediasubscription")}</td>
                            </tr> */}
                        </tbody>
                    </Table>
                </Row>
                </>) : (<></>)}

              
            </Container>
            </div>
        </>
    );
}

export default Pricing;
